import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useFormatValidUntil = ({ expiresAt }: { expiresAt: Date }) => {
  const { t: tCommon, i18n } = useTranslation('common');

  const validUntilDate = useMemo(
    () =>
      expiresAt.toLocaleString(i18n.language, {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      }),
    [expiresAt, i18n.language],
  );

  const validUntilWithText = useMemo(
    () => `${tCommon('validUntil')}: ${validUntilDate}`,
    [tCommon, validUntilDate],
  );

  return { validUntilWithText, validUntilDate };
};
